
import VueLoader from '../vue-loader'
import InfoRequestForm from './form'

document.addEventListener('turbo:load', () => {
  VueLoader.loadVueComponent(InfoRequestForm, document.getElementById('infoRequestForm'))
})
